export default __webpack_public_path__ + "assets/images/ef297bf711a01668e3ce9c60c031a8e9.png";